<template>
  <div class="price">
    <div v-if="selected_customer">
      <div v-if="pprix !== 0">
        <div class="price-container">
          <span class="unit-price">{{$_('unit_price')}}</span>
          <div class="price-group">
            <span>{{getPPrix}} {{getPcDev}} / {{getPUnitPrix}} HT</span>
            <span class="prix-total prix-total-ttc">{{getPPrixTTC}} {{getPcDev}} / {{getPUnitPrix}} TTC</span>
          </div>
        </div>
        <div class="price-container">
          <span class="total-price">{{$_('total_price')}}</span>
          <div class="price-group">
            <span class="prix-total">{{getPmontant}} {{getPcDev}} HT</span>
            <span class="prix-total prix-total-ttc">{{getPmontantTTC}} {{getPcDev}} TTC</span>
          </div>
        </div>
      </div>
      <div v-else>
        <span class="error">{{$_('no_price_for_customer')}}</span>
      </div>
    </div>
    <div v-else>
      <span class="error">{{$_('please_select_customer')}}</span>
    </div>
  </div>
</template>

<script>
import productService from "@/modules/produit/services/productService";

export default {
  data() {
    return {
      pcdev: "",
      pmontant: 0,
      pmontantttc: 0,
      pprix: 0,
      pprixttc: 0,
      punit_prix: "",
      selected_customer: false,
    };
  },
  created() {
    if (this.$store.getters['application/get_application_customer'].TNCLI !== undefined) {
      this.getPriceInfo();
      this.selected_customer = true;
    }
  },
  methods: {
    getPriceInfo() {
      productService.getPriceInfo({
        pmod: this.$store.getters['produit/get_fmod']  !== '' ? this.$store.getters['produit/get_fmod'] : null,
        ptail1: this.$store.getters['produit/get_ftail1']  !== '' ? this.$store.getters['produit/get_ftail1'] : null,
        ptail2: this.$store.getters['produit/get_ftail2']  !== '' ? this.$store.getters['produit/get_ftail2'] : null,
        popt: this.$store.getters['produit/get_fopt']  !== '' ? this.$store.getters['produit/get_fopt'] : null,
        pcol: this.$store.getters['produit/get_fcol']  !== '' ? this.$store.getters['produit/get_fcol'] : null,
        pmarq: this.$store.getters['produit/get_fmarq']  !== '' ? this.$store.getters['produit/get_fmarq'] : null,
        pqte: this.$store.getters['produit/get_fqte']  !== '' ? this.$store.getters['produit/get_fqte'] : null,

      }).then(res => {

        if(res.data !== null) {
          this.pcdev = res.data.PCDEV;

          this.pmontant = res.data.PMONTANT; // HT
          this.pmontantttc = res.data.PMONTANTTTC; // TTC

          this.pprix = res.data.PPRIX; // HT
          this.pprixttc = res.data.PPRIXTTC; // TTC

          this.punit_prix = res.data.PUNIT_PRIX;

          this.$store.dispatch('produit/SELECT', {key: 'total_price', value: res.data.PMONTANT});
          this.$store.dispatch('produit/SELECT', {key: 'price_unit', value: res.data.PUNIT_PRIX});
        }
  

        this.$store.dispatch('produit/SELECT', {key: 'launch_price', value: false});

      }).catch(err => {
        console.error(err);
      });
    },
  },
  computed: {
    getPcDev() {
      if (this.pcdev === "") {
        return "-";
      }
      return this.pcdev;
    },
    getPmontant() {
      if (this.pmontant === 0) {
        return "-";
      }
      return this.pmontant;
    },
    getPmontantTTC() {
      if (this.pmontantttc === 0) {
        return "-";
      }
      return this.pmontantttc;
    },
    getPPrix() {
      if (this.pprix === 0) {
        return "-";
      }
      return this.pprix;
    },
    getPPrixTTC() {
      if (this.pprixttc === 0) {
        return "-";
      }
      return this.pprixttc;
    },
    getPUnitPrix() {
      if (this.punit_prix === '') {
        return "-";
      }
      return this.punit_prix;
    },
    getLaunchPrice() {
      return this.$store.getters['produit/get_launch_price'];
    },
  },
  watch: {
    getLaunchPrice(val) {
      if(val) {
        this.getPriceInfo();
      }
    },
  }
};
</script>

<style scoped>
.total-price {
  text-transform: uppercase;
  font-weight: bold;
}
.price-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  min-width: 200px;
}
.prix-total {
  font-weight: bold;
  color: red;
  font-size: var(--fz-md);
}
.unit-price {
  font-size: var(--fz-sm);
  color: #8b8b8b;
}
.error {
  color: red;
  font-size: var(--fz-md);
}
.price-group {
  display: flex;
  flex-direction: column;
}
.price-group .prix-total.prix-total-ttc {
  font-size: .65rem;
  margin: 3px 0px;
  color: #000;
}
</style>